import { type FC } from "react";

import { PersonalDevelopmentLogo } from "@/components/icons";
import { ChildCard, ComingSoonCard } from "@/components/molecules/ChildCard";

/**
 * **PersonalDevelopmentApp**
 *
 * Zwischenebene für Personal Development Tools unter Nexus.
 * Zeigt verfügbare Personal Development-Integrationen an.
 *
 * @returns Personal Development app component
 *
 */

export const PersonalDevelopmentApp: FC = () => {
  return (
    <div className="min-h-screen bg-background p-6 space-y-6 text-primary">
      <header className="flex items-center justify-between">
        <div className="flex items-center space-x-2">
          <PersonalDevelopmentLogo size="app" />
          <h1 className="text-2xl font-bold">Personal Development</h1>
        </div>
      </header>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {/* MiracleFlow Card */}
        <ChildCard
          ctaText="Start Routine"
          description="Transform your daily routine with structured morning and evening practices for personal growth."
          gradient={{ from: "from-purple-500", to: "to-purple-600" }}
          iconLetter="M"
          title="Miracle Flow"
          to="/nexus/personal-development/miracle-flow"
        />

        {/* Future Personal Development Tools */}
        <ComingSoonCard
          description="Additional personal development and growth tools will be available here."
          gradient={{ from: "from-neutral-600", to: "to-neutral-700" }}
          iconLetter="+"
          title="More Tools"
        />
      </div>
    </div>
  );
};
